import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { IMAGES } from "../../lib/constants";

export const Hero = ({ t }) => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative min-h-screen flex items-end overflow-hidden"
    style={{ background: "var(--green-800)" }}
  >
    <img
      src={IMAGES.hero}
      alt="International workers on a modern European industrial facility — Kadra Talent workforce"
      className="absolute inset-0 w-full h-full object-cover editorial-img"
    />
    <div className="absolute inset-0 hero-overlay-photo" />

    <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 pb-20 md:pb-28 pt-32">
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-10">
          <Reveal>
            <span className="eyebrow on-dark mb-10">{t.hero.label}</span>
          </Reveal>
          <Reveal delay={120}>
            <h1
              className="display-xl on-dark text-[40px] sm:text-[56px] md:text-[72px] lg:text-[84px] mt-8"
              style={{ lineHeight: 1.05 }}
            >
              <span style={{ color: "var(--white)" }}>{t.hero.title1}</span>
              <br />
              <em
                className="not-italic"
                style={{
                  fontFamily: "var(--font-display)",
                  color: "var(--gold-300)",
                }}
              >
                {t.hero.title2}
              </em>
            </h1>
          </Reveal>
          <Reveal delay={260}>
            <p
              className="mt-8 md:mt-10 max-w-3xl text-base md:text-lg leading-relaxed"
              style={{ color: "var(--gold-300)" }}
            >
              {t.hero.sub}
            </p>
          </Reveal>
          <Reveal delay={380}>
            <div className="mt-10 flex flex-wrap items-center gap-5">
              <a href="#contact" data-testid="hero-cta" className="btn btn-gold">
                {t.hero.cta}
                <ArrowUpRight size={16} />
              </a>
              <a
                href="#cases"
                data-testid="hero-secondary"
                className="btn btn-ghost-dark"
              >
                {t.hero.ctaSecondary}
                <ArrowRight size={16} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal delay={500}>
        <div
          className="mt-20 md:mt-28 pt-8 flex flex-col md:flex-row gap-4 md:gap-12 items-start md:items-center"
          style={{ borderTop: "1px solid var(--border-on-dark)" }}
        >
          <span
            className="eyebrow on-dark"
            style={{ color: "rgba(255,255,255,0.55)" }}
          >
            {t.hero.trustLabel}
          </span>
          <span
            className="text-sm md:text-base max-w-2xl"
            style={{ color: "var(--gold-300)" }}
          >
            {t.hero.trust}
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
